import { render } from "./ManagementCard.vue?vue&type=template&id=04e36692&scoped=true"
import script from "./ManagementCard.vue?vue&type=script&lang=js"
export * from "./ManagementCard.vue?vue&type=script&lang=js"

import "./ManagementCard.vue?vue&type=style&index=0&id=04e36692&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04e36692"]])

export default __exports__